export default __webpack_public_path__ + "static/media/Flag_of_Kyrgyzstan.2ac397dc.svg";